export const STYLE_MAP = {
  default: {
    modeAllWidth: '16px',
    modeAllLeft: '0px'
  },
  colmo: {
    modeAllWidth: '8px',
    modeAllLeft: '36px'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-noticebar/style.js